import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/ar/poi-card/poi-card.js';
      import {PoiCardClickDetail, PointerDirection} from '@oicl/openbridge-webcomponents/dist/ar/poi-card/poi-card.js';
import {ObcPoiCardHeaderVariant} from '@oicl/openbridge-webcomponents/dist/ar/poi-card-header/poi-card-header.js';

      export interface Props {
     pointerDirection?: PointerDirection;
     fixedSize?: boolean;
     showHeader?: boolean;
     headerVariant?: ObcPoiCardHeaderVariant;
     index?: string;
     cardTitle?: string;
     description?: string;
     source?: string;
     timestamp?: string;
     hasLeadingIcon?: boolean;
     hasCloseButton?: boolean;
     interactive?: boolean;
     hasAlert?: boolean
   }

      
  
      export type {PoiCardClickDetail, PointerDirection} from '@oicl/openbridge-webcomponents/dist/ar/poi-card/poi-card.js';
export type {ObcPoiCardHeaderVariant} from '@oicl/openbridge-webcomponents/dist/ar/poi-card-header/poi-card-header.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPoiCard',
  props: {
    pointerDirection: {},
    fixedSize: { type: Boolean },
    showHeader: { type: Boolean },
    headerVariant: {},
    index: {},
    cardTitle: {},
    description: {},
    source: {},
    timestamp: {},
    hasLeadingIcon: { type: Boolean },
    hasCloseButton: { type: Boolean },
    interactive: { type: Boolean },
    hasAlert: { type: Boolean }
  },
  emits: ["card-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onCardClick: (event: CustomEvent<PoiCardClickDetail>) => emit('card-click', event as CustomEvent<PoiCardClickDetail>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-poi-card',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})